<script lang="ts" setup>
import { maxContentSize } from '~/constants'
import { useConfigStore } from '~/store'
import type { ContentType } from '~/types'

const config = useConfigStore()

const route = useRoute()
const fetchId = route.params.fetchId as string
const channel = route.params.channel as ContentType

const showSide = ref(true)

const { state: content, isReady } = useAsyncState(async () => {
  try {
    const res = await requestContent(channel, fetchId)
    config.setState({
      leaderboardPID: 'leaderboard_watch',
      contentType: res?.type,
      contentId: res?.id,
      showAds: config.showAds,
    })

    return res
  }
  catch (error) {
    showError({
      statusCode: 404,
      statusMessage: 'Page Not Found',
    })
  }
}, null)

useHead({
  title: content.value?.title,
})

useEventListener(window, 'message', async (e: MessageEvent) => {
  if (e?.data === 'load_next_video') {
    const nextVideoId = Number(fetchId) >= maxContentSize - 1 ? 0 : Number(fetchId) + 1
    await navigateTo(`/watch/${channel}/${nextVideoId}`)
  }
})
</script>

<template>
  <div class="flex flex-col h-full lg:flex-row">
    <main class="relative bg-black aspect-[4/3] lg:flex-1 lg:h-full group">
      <div
        class="absolute flex items-center justify-between w-full px-2 z-[1] top-2 group-hover:opacity-100 transition duration-300"
        :class="showSide ? 'opacity-100' : 'opacity-0'"
      >
        <h2 class="text-xl font-normal truncate">
          {{ content?.title }}
        </h2>
        <div class="hidden lg:block">
          <Icon
            name="i-heroicons-information-circle-20-solid"
            size="2rem"
            class="transition cursor-pointer hover:opacity-80"
            :class="showSide ? 'text-green-400' : 'text-gray-400'"
            @click="showSide = !showSide"
          />
        </div>
      </div>
      <!-- config.showAds does not apply the the video player, always show ads here -->
      <ContentPlacement v-if="isReady" placement-id="video_player_watch" />
    </main>

    <div class="relative w-full flex-1 lg:flex-none lg:w-[301px]" :class="showSide ? 'block' : 'hidden'">
      <aside class="absolute top-0 right-0 z-10 w-full h-full flex flex-col lg:w-[301px] lg:fixed lg:h-screen bg-[#111] ">
        <!-- Divider -->
        <div class="relative sm:mb-4 top-4 lg:m-0">
          <div class="absolute inset-0 flex items-center" aria-hidden="true">
            <div class="w-full border-t border-green-400" />
          </div>
          <div class="relative flex justify-center">
            <span class="px-3 text-lg font-medium text-white bg-[#111]">Video Info</span>
          </div>
        </div>

        <div class="flex flex-col flex-1 overflow-scroll">
          <section v-show="content" class="px-2 py-4">
            <h3>
              {{ content?.title }}
            </h3>

            <div class="flex gap-4 my-2">
              <label v-if="content?.duration">
                Play Time:
                <span class="text-xs font-semibold text-green-400">
                  {{ content?.duration }}
                </span>
              </label>
            </div>

            <p class="text-sm font-extralight">
              {{ content?.description }}
            </p>
          </section>

          <section class="self-center mt-auto lg:absolute lg:bottom-0  w-[300px] h-[250px] flex-shrink-0">
            <!-- <ContentPlacement v-if="config.showAds" placement-id="mrec_watch" /> -->
          </section>
        </div>
      </aside>
    </div>
  </div>
</template>

<style scoped></style>
